import React, { useEffect, useRef, useState } from 'react'

interface UseVisibilityObserverReturn {
  readonly ref: React.RefObject<HTMLElement | null>
  readonly isVisible: boolean
}

export function useVisibilityObserver(threshold = 0.3): UseVisibilityObserverReturn {
  const ref = useRef<HTMLElement | null>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          setIsVisible(entry.isIntersecting)
        }
      },
      { threshold },
    )

    observer.observe(element)

    return () => {
      observer.disconnect()
    }
  }, [threshold])

  return { ref, isVisible }
}
